import styled from 'styled-components';
import IconButton from 'components/IconButton';
import { XOutline } from 'icons';

export const Root = styled(IconButton)`
  border: none;
`;

export const Icon = styled(XOutline)`
  height: 100%;
  width: 100%;
`;
